import { render } from "./UpgradePackageView.vue?vue&type=template&id=f5f4806e&scoped=true"
import script from "./UpgradePackageView.vue?vue&type=script&lang=js"
export * from "./UpgradePackageView.vue?vue&type=script&lang=js"

import "./UpgradePackageView.vue?vue&type=style&index=0&id=f5f4806e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f4806e"]])

export default __exports__